var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15771",
    "data-name": "Path 15771",
    d: "M9.72-9.89,9.5-9.669a.375.375,0,0,0,0,.53l2.623,2.608H.375A.375.375,0,0,0,0-6.156v.312a.375.375,0,0,0,.375.375H12.121L9.5-2.861a.375.375,0,0,0,0,.53l.221.221a.375.375,0,0,0,.53,0l3.64-3.625a.375.375,0,0,0,0-.53L10.25-9.89A.375.375,0,0,0,9.72-9.89Z",
    transform: "translate(0 10)",
    fill: "#a2a2a2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.52ed0b7a9f948c43a874e2795b9c61f4.svg";
export { ForwardRef as ReactComponent };